import { render, staticRenderFns } from "./jobfair.vue?vue&type=template&id=706fd054&scoped=true"
import script from "./jobfair.vue?vue&type=script&lang=js"
export * from "./jobfair.vue?vue&type=script&lang=js"
import style0 from "./jobfair.vue?vue&type=style&index=0&id=706fd054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706fd054",
  null
  
)

export default component.exports